import { useMemo } from "react";

import { useTranslation } from "@/Common/CustomHooks/useTranslation";

import styles from "../FaxDirectoryForm.module.scss";

interface IDirectoryHeaderProps {
    labelKey: string;
    className?: string;
    onAdd?: () => void;
    shouldDisplayAddLabel?: boolean;
    onEdit?: () => void;
    shouldDisplayEditLabel?: boolean;
}

export function DirectoryHeader(props: IDirectoryHeaderProps): JSX.Element {
    const { getText } = useTranslation();
    const shouldDisplayAddLabel = useMemo(
        () => props.onAdd && (props.shouldDisplayAddLabel ?? true),
        [props.shouldDisplayAddLabel, props.onAdd]
    );

    const shouldDisplayEditLabel = useMemo(
        () => props.onEdit && (props.shouldDisplayEditLabel ?? true),
        [props.shouldDisplayEditLabel, props.onEdit]
    );

    return (
        <div className={`${styles.header} ${props.className ?? ""}`}>
            <label>{getText(props.labelKey)}</label>
            {shouldDisplayAddLabel && <a className={styles.link} onClick={() => props.onAdd?.()}>{getText("AddLabel")}</a>}
            {shouldDisplayEditLabel && <a className={styles.link} onClick={() => props.onEdit?.()}>{getText("EDITLabel")}</a>}
        </div>
    );
}
